import type { FileProps } from '../stores/PartStore';

/** Most parts one quote can hold through the upload form. */
export const PART_LIMIT = 100;

export const isPartLimitReached = (count: number) => count >= PART_LIMIT;

export const partLimitMessage = `You can add up to ${PART_LIMIT} parts. Remove some parts to add more.`;

/**
 * The single part to upload on its own after a pause, or nothing. While a ZIP is still
 * being read more files are coming, so the first one must not go alone. A part that
 * already failed is not retried here; the customer retries with Continue.
 */
export const getAutoUploadPart = (
    parts: Array<FileProps>,
    { busy, forStaff }: { busy: boolean; forStaff: boolean }
): FileProps | undefined => {
    if (busy || parts.length !== 1) return undefined;

    const part = parts[0];
    if (forStaff) return part;

    const hasFiles = Boolean(part['3D File'] || part['2D File'] || part['Additional File']?.length);
    return hasFiles && !part.uploading && !part.uploadError ? part : undefined;
};
